// Vue Plugins
import common from '@/mixins/common';
import store from '@/store';
import {I18n, loadLanguageAsync} from '@/utils/i18n-setup-utils';
import vue from 'vue';
import v2s from 'vue-script2';

// Vue Components
import compareRackContainer from '@/components/compare/CompareRackContainer';
import compareBar from '@/components/containers/plp/CompareBar';
import LiveChat from '@/components/LiveChat';
import SemRush from '@/components/scripts/SemRush';
import RefLink from '@/components/RefLink';
import TrekButton from '@/components/TrekButton';
import TrekFooter from '@/components/TrekFooter';
import TrekLink from '@/components/TrekLink';
import {PdlToast} from '@pedal/pdl-toast';
import {PdlBadge} from '@pedal/pdl-badge';
import {PdlSwatch} from '@pedal/pdl-swatch';
import {PdlTabs, PdlTabPane, PdlTabNav, PdlTabBar} from '@pedal/pdl-tabs';

// Vue Nav Components
import NavCategoriesLink from '@/navigation/components/NavCategoriesLink';
import NavCompactContainer from '@/navigation/containers/NavCompactContainer';
import NavLargeContainer from '@/navigation/containers/NavLargeContainer';
import NavUtilityBarB2cContainer from '@/navigation/containers/NavUtilityBarB2cContainer';
import NavCategoriesLayout from '@/navigation/layouts/NavCategoriesLayout';
import NavOverlayCompactLayout from '@/navigation/layouts/NavOverlayCompactLayout';
import NavApp from '@/navigation/NavApp';

// Vue components used site-wide
import {nonCriticalCssLoader} from '@/entryPoints/lib/non-critical-css-loader';
import emailSignup from '@/modules/EmailSignup';
import explodingAccordion from '@/modules/explodingAccordion';
import geoPrompt from '@/modules/geoPrompt';
import liveChat from '@/modules/liveChat';
import loadingIndicator from '@/modules/loadingIndicator';
import menuSelector from '@/modules/MenuSelector';
import miniCart from '@/modules/MiniCart';

// Utils
import toggler from '@/modules/Toggler';
import {updateASMHeader} from '@/utils/asmAdjustments';
import '@/utils/axios/index';

// Directives
import DebugHighlight from '@/directives/debug-highlight.directive';

//Misc
import editorialHighlightComponent from '@/modules/editorialHighlightComponent';

class ShellBase {
  /**
   * Initialize a new instance of the ShellBase class.
   * @param pageComponents
   */
  constructor(pageComponents = {}, vueRouter = {}) {
    this.vue = vue;
    this.store = store;
    this.pageComponents = pageComponents;
    this.router = vueRouter;

    vue.config.devtools = !window.ACC.config.isProduction;
    vue.config.silent = window.ACC.config.isProduction;

    // Directives
    vue.directive('debug-highlight', DebugHighlight);

    // // Set dynamic path for webpack chunks.
    if (!window['webpackHotUpdatetbc']) {
      const cdnDynamicFilesRoot = window.ACC.config.cdnDynamicFilesRoot;
      // eslint-disable-next-line no-undef
      __webpack_public_path__ = `${cdnDynamicFilesRoot}${!cdnDynamicFilesRoot.endsWith('/') ? '/' : ''}`;
    }
  }

  /**
   * Register a list of components in a global context.
   * @param components
   */
  registerVueComponents(components) {
    if (!components || !Object.keys(components).length) {
      return;
    }

    Object.keys(components).forEach((name) => {
      const component = components[name];
      this.vue.component(name, component.default || component);
    });
  }

  /**
   * Initialize Vue
   */
  initializeVue() {
    this.loadPlugins();

    const vm = new vue({
      router: this.router,
      store,
      i18n: I18n,
      el: '#page',
      components: {
        ...this.pageComponents,
        compareBar,
        compareRackContainer,
        TrekButton,
        TrekLink,
        TrekFooter,
        RefLink,
        NavApp,
        NavLargeContainer,
        NavCategoriesLayout,
        NavCategoriesLink,
        NavCompactContainer,
        NavOverlayCompactLayout,
        NavUtilityBarB2cContainer,
        PdlBadge,
        PdlSwatch,
        PdlTabs,
        PdlTabPane,
        PdlTabNav,
        PdlTabBar,
        LiveChat,
        SemRush,
      },
      data() {
        return {
          isLoading: false,
        };
      },

      beforeMount() {
        loadLanguageAsync(window.ACC.languageISO).then(() => {
          this.isLoading = true;
        });
      },
      methods: {
        toast(options) {
          return this.$notify(options);
        },

        mounted() {
          if (this.$validator) {
            this.$validator.localize(this.$store.state.vvLocale);
          }
        },
      },
    });

    store.commit('backend/setB2b', window.ACC.isB2Bsite);
    window.store = store;
    window.toast = vm.toast;
    window.vm = vm;
  }

  loadPlugins() {
    // Load common plugins here
    vue.use(v2s);
    vue.mixin(common);
    vue.prototype.$notify = PdlToast;
  }

  preLoadInits() {
    nonCriticalCssLoader();
  }

  globalDocumentReadyInits() {
    // adding a global loading indicator
    window.loadingIndicator = loadingIndicator();

    // Live Chat
    liveChat();

    // Enables top nav interactions
    menuSelector($(document));

    // ASM Adjustments
    updateASMHeader();

    // Collapsing blocks handler
    const togglers = $('[data-toggler]');
    togglers.each((i, t) => {
      toggler($(t));
    });

    // Geo Prompt
    if ($('.geo-prompt-modal').length) {
      geoPrompt();
    }

    // Footer Email Sign Up Script
    emailSignup();
  }

  globalOnLoadInits() {
    $(window).trigger('resize');
    miniCart(document);

    // Footer expanding accordions in mobile
    const explodingAccordions = $(document).find('[data-accordion-explode]');
    explodingAccordions.each((i, t) => {
      explodingAccordion($(t));
    });

    // Footer hide shop links in kiosk mode
    if ($('#isKioskMode').length) {
      $('#footerRetailerLink').parent().hide();
      $('#retailersFooterLinkElectra').parent().hide();
    }

    //Check if editorialHighLightComponet is present in page
    if ($('.js-editorial-highlight-component').length) {
      editorialHighlightComponent();
    }
  }
}

export {ShellBase};
